import { createOwnerWallet } from '../createOwnerWallet/createOwnerWallet.js';
import '@dynamic-labs/sdk-api';
import '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import '../../constants/colors.js';
import '../../constants/values.js';
import '../../../shared/utils/classes/storage/localStorage.js';
import 'viem';
import '@dynamic-labs/utils';
import '../../../shared/consts/index.js';
import '../../../../../_virtual/_tslib.js';
import '@dynamic-labs/multi-wallet';
import 'viem/chains';

const getEOAWallet = (primaryWallet, verifiedCredentials) => {
    if (!primaryWallet) {
        return primaryWallet;
    }
    try {
        return createOwnerWallet(primaryWallet, verifiedCredentials);
    }
    catch (e) {
        return primaryWallet;
    }
};

export { getEOAWallet };
